import { LocationNumbersService } from "../../../services"

const liftLocationTwilioSuspension = async function(  { commit, state, getters },
  payload) {
  try {
    const res = await LocationNumbersService.liftLocationTwilioSuspension(
      payload
    )
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}


export default liftLocationTwilioSuspension
